<template>
  <div class="wallet">
    <div class="top">
      <h3>账户余额</h3>
      <p class="balance">{{userBaseInfo.smallChange}}元</p>
      <nav class="nav">
        <ul>
          <li class="withdraw" @click="close">提现</li>
          <li class="recharge"><router-link to="/person/wallet/recharge">充值</router-link></li>
          <li class="editPwd" @click="closePay">修改支付密码</li>
        </ul>
      </nav>
    </div>
    <div class="content">
      <h3>明细</h3>
      <ul>
        <li v-for="(item, index) in walletList" :key="item.id">
          <div class="left">
            <p class="title">{{item.description}}</p>
            <p class="time">{{item.createDate}}</p>
          </div>
          <div class="right">{{item.tradeType ? '-'+item.amountOut : '+'+item.amountIn}}</div>
        </li>
      </ul>
      <!--分页-->
      <div class="pagin"><pagination :pageCount="pageCount" @pageSize="pageSize" /></div>
    </div>
    <!--提现-->
    <withdraw v-if="isShow" @close="close" />
    <!--修改支付密码-->
    <change-pay-pwd v-if="isPay" @closePay="closePay"  />
  </div>
</template>

<script>
import Pagination from '../../../components/Pagination'
import Withdraw from '../../../components/Person/Withdraw'
import ChangePayPwd from '../../../components/Person/ChangePayPwd'
import {mapState} from 'vuex'
import {reqMemberAccountTrade} from '../../../api'
export default {
  data() {
    return{
      isShow: false, // 显示提现
      isPay: false, // 显示修改支付密码
      walletList: [], // 账户列表
      pageCount: 0 // 总页数
    }
  },
  created() {
    this._reqMemberAccountTrade()
  },
  methods: {
    // 获取账号余额明细
    _reqMemberAccountTrade(val=1) {
      reqMemberAccountTrade({pageIndex:val}).then(res => {
        console.log(res)
        if(res.code === 200) {
          this.walletList = res.data.bussData
          this.pageCount = res.data.pageCount
        }
      })
    },
    // 分页
    pageSize(val) {
      this._reqMemberAccountTrade(val)
    },
    // 关闭提现
    close () {
      this.isShow = !this.isShow
    },
    // 关闭修改支付密码
    closePay () {
      this.isPay = !this.isPay
    },
  },
  computed: {
    ...mapState(['userBaseInfo'])
  },
  components: {
    Pagination,
    Withdraw,
    ChangePayPwd
  }
}
</script>

<style scoped lang="less" type="text/less">
.wallet{
  .top{
    h3{
      font-size: 24px;
      margin-top:60px;
    }
    .balance{
      margin-top:18px;
      color:#E60012;
    }
    .nav{
      margin-top:20px;
      padding-bottom: 30px;
      border-bottom:1px solid #e1e1e1;
      ul{
        display: flex;
        li{
          width: 90px;
          height: 36px;
          box-sizing: border-box;
          text-align: center;
          line-height: 36px;
          border-radius: 18px;
          font-weight: bold;
          margin-right: 30px;
          cursor: pointer;
          &.withdraw{
            border:1px solid #61aee6;
            color:#61aee6;
          }
          &.recharge{
            background: #61aee6;
            color:#fff;
          }
          &.editPwd{
            width: 119px;
            border:1px solid #d1d1d1;
            color:#666;
          }
        }
      }
    }
  }
  .content{
    h3{
      margin:30px 0;
      font-size: 24px;
    }
    ul{
      li{
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        padding:27px 61px 28px 30px;
        border:1px solid #f1f1f1;
        box-shadow:0px 3px 7px 0px rgba(0, 0, 0, 0.08);
        border-radius:4px;
        .left{
          .title{
            font-size: 16px;
          }
          .time{
            margin-top:20px;
            color:#999;
          }
        }
        .right{
          font-size: 24px;
        }
      }
    }
    .pagin{
      margin-top:40px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/Wallet.vue